import { LiveStateEnum } from '@shared/enums/live';

/** The LIVE.JOIN_LIVE error key for a live found by its code, null when it can be joined. */
export function sessionCodeOutcome(state: LiveStateEnum): string | null {
  switch (state) {
    case LiveStateEnum.InProgress:
      return null;
    case LiveStateEnum.Created:
    case LiveStateEnum.Scheduled:
      return 'LIVE.JOIN_LIVE.NOT_STARTED';
    case LiveStateEnum.Stopped:
      return 'LIVE.JOIN_LIVE.ALREADY_ENDED';
    case LiveStateEnum.Cancelled:
    default:
      return 'LIVE.JOIN_LIVE.WRONG_SEARCH_NAME';
  }
}
